import React from 'react';
import { Link } from 'react-router-dom';
import QRScanner from '../components/QRScanner';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleScanSuccess = (result: string) => {
    try {
      // QRコードに格納されたURLから席番号を取得
      const url = new URL(result);
      const pathSegments = url.pathname.split('/');
      const seatNumber = pathSegments[pathSegments.length - 1];
      
      // 席情報ページへ遷移
      navigate(`/seat/${seatNumber}`);
    } catch (error) {
      console.error('無効なQRコードです:', error);
      alert('無効なQRコードです。もう一度お試しください。');
    }
  };

  const handleScanError = (error: string) => {
    console.error('QRコードのスキャンに失敗しました:', error);
  };

  return (
    <div className="home-page">
      <div className="container">
        <header>
          <h1>席抽選システム</h1>
        </header>
        
        <main>
          <div className="feature-buttons">
            <Link to="/lottery" className="feature-button lottery">
              席を抽選する
            </Link>
            
            <Link to="/admin" className="feature-button admin">
              管理者ページ
            </Link>
          </div>
          
          <div className="scanner-section">
            <h2>席QRコードをスキャン</h2>
            <p>席に設置されたQRコードをスキャンして、誰の席かを確認できます。</p>
            
            <QRScanner 
              onScanSuccess={handleScanSuccess} 
              onScanError={handleScanError}
            />
          </div>
        </main>
        
        <footer>
          <p>© {new Date().getFullYear()} 席抽選システム</p>
        </footer>
      </div>
    </div>
  );
};

export default HomePage; 